import type { AllLeaguesSection } from '@/components/league-navigator/utils/all-leagues-utils';

import type { SportWithLeagues } from '../hooks/use-sports';

export const buildAllLeaguesSections = (sports: SportWithLeagues[]): AllLeaguesSection[] =>
    sports.map(sport => ({
        sport: sport.name,
        data: sport.leagues.map(league => ({
            id: league.id,
            label: league.name,
            image: league.logo_url ? { uri: league.logo_url } : undefined,
            isOffseason: league.status === 'offseason',
        })),
    }));
